import script from "./LeavePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeavePopup.vue?vue&type=script&setup=true&lang=ts"

import "./LeavePopup.vue?vue&type=style&index=0&id=cbfb72e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbfb72e6"]])

export default __exports__